// Structured Content Interface (CMS-agnostic). Presentation consumes ONLY these.
import data from "./content.json";

export const brand = data.brand;
export const nav = data.nav;
export const home = data.home;
export const principle = data.principle;
export const projectApproach = data.projectApproach;
export const technology = data.technology;
export const value = data.value;
export const safety = data.safety;
export const resources = data.resources;
export const company = data.company;
export const investors = data.investors;
export const contact = data.contact;
export const footer = data.footer;
export const market = data.market;
export const irContact = data.irContact;
export const hydralytica = data.hydralytica;
export const about = data.about;
export const leadership = data.leadership;
export const careers = data.careers;
export const globalPresence = data.globalPresence;
export const legal = data.legal;
export const productSeries = data.productSeries;

export const listBenefitPages = () => data.benefitPages;
export const getBenefitPage = (slug) => data.benefitPages.find((b) => b.slug === slug);

export const listProducts = () => data.products;
export const getProduct = (slug) => data.products.find((p) => p.slug === slug);
export const getSeries = (id) => data.productSeries.find((s) => s.id === id);
export const listIndustries = () => data.industries;
export const getIndustry = (slug) => data.industries.find((i) => i.slug === slug);
export const listApplications = () => data.applications;
export const getApplication = (slug) => data.applications.find((a) => a.slug === slug);

export const publicClaims = (claims = []) => claims.filter((c) => c.approved_for_public_web === true);

export default data;
